import React, { useState } from 'react';
import { User, LogOut, Smartphone, Download, Sparkles } from 'lucide-react';
import Alert from '../Alert/Alert';
import { USER_ROLES } from '../../../utils/constants';

const SidebarFooter = ({
  userRole,
  user,
  isCollapsed,
  activeItem,
  onNavigate,
  onLogout
}) => {
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const androidAppUrl = process.env.REACT_APP_ANDROID_APP_URL || '';
  const isEmployeeRole = userRole !== USER_ROLES.SUPER_ADMIN;

  const handleLogoutClick = () => {
    setShowLogoutAlert(true);
  };

  const handleLogoutConfirm = () => {
    onLogout();
  };

  return (
    <div className={`flex-shrink-0 border-t border-[#EEF2F7] bg-white ${isCollapsed ? 'p-1.5' : 'p-2.5'} transition-all duration-150`}>
      <div className="space-y-1">
        {/* Mobile App Download Card for Employees */}
        {!isCollapsed && isEmployeeRole && (
          <div className="mb-2 p-2 rounded-lg border border-blue-100 bg-gradient-to-br from-blue-50/70 to-indigo-50/70">
            <div className="flex items-start gap-2">
              <div className="w-6 h-6 rounded-md bg-[#0F2942] text-white flex items-center justify-center flex-shrink-0 mt-0.5 shadow-xs">
                <Smartphone className="w-3 h-3 stroke-[2]" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[11px] font-semibold text-slate-800 leading-tight">Mobiloitte HRMS App</p>
                <p className="text-[9.5px] text-slate-600 leading-snug">Approvals & attendance on mobile.</p>
              </div>
            </div>
            {androidAppUrl ? (
              <a
                href={androidAppUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 w-full inline-flex items-center justify-center gap-1 px-2.5 py-1 rounded-md bg-[#0F2942] text-white text-[10px] font-semibold hover:bg-[#0B2033] transition-colors shadow-xs"
              >
                <Download className="w-2.5 h-2.5 stroke-[2]" />
                Download App
              </a>
            ) : (
              <div className="mt-2 px-2 py-0.5 rounded-md bg-white/80 border border-slate-200 text-[9px] text-slate-500 text-center font-medium">
                App link coming soon
              </div>
            )}
          </div>
        )}




        {/* Logout Action */}
        <div
          onClick={handleLogoutClick}
          className={`flex items-center h-[42px] px-3 rounded-[8px] cursor-pointer text-[#64748B] hover:bg-red-50 hover:text-red-600 transition-all duration-150 ${
            isCollapsed ? 'justify-center px-0' : 'gap-2.5'
          }`}
          title={isCollapsed ? 'Logout' : undefined}
        >
          <LogOut className="h-5 w-5 flex-shrink-0 stroke-[2]" />
          {!isCollapsed && <span className="text-[15px] font-semibold">Logout</span>}
        </div>
      </div>

      {/* Logout Confirmation Alert */}
      <Alert
        isOpen={showLogoutAlert}
        onClose={() => setShowLogoutAlert(false)}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        type="warning"
        showCancel={true}
        confirmText="YES"
        cancelText="NO"
        onConfirm={handleLogoutConfirm}
        onCancel={() => setShowLogoutAlert(false)}
      />
    </div>
  );
};

export default SidebarFooter;
